var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.computedClass }, [
    _c(
      "label",
      { attrs: { for: _vm.id ?? _vm.name, "aria-label": _vm.name } },
      [
        _c(
          "input",
          _vm._b(
            {
              attrs: {
                id: _vm.id ?? _vm.name,
                role: "switch",
                "aria-label": "Controle de seleção",
                name: _vm.name,
                type: "checkbox",
                disabled: _vm.disabled,
              },
              on: { click: (e) => _vm.$emit("onClick", e) },
            },
            "input",
            _vm.$attrs,
            false
          )
        ),
        _c("span", { staticClass: "jade-switch__track" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }